import api from "../../api";
import {typedQuery} from "../typing";

export const scimConfigs = typedQuery(["scimConfigs"], async () => {
  return await api.scim.listConfigs();
});
